export default "__VITE_ASSET__7b964fff__"